import { Channel } from "@repo/types/Channel";
import { ApiURL, Request } from "@services/api.service";

export const ChannelDao = {
    getOne: async (channel: string | number, platform: string): Promise<Channel> => {
        try {
            console.log(channel, platform)
            const info: any = await Request(ApiURL + `channel/info/get`, {
                headers: { "Content-type": "application/json" },
                method: "POST",
                body: JSON.stringify({ channel: String(channel), platform: String(platform) }),
            })
            const stat: any = await Request(ApiURL + `channel/stat/get`, {
                headers: { "Content-type": "application/json" },
                method: "POST",
                body: JSON.stringify({ channel: String(channel), platform: String(platform) }),
            })
            return new Channel({ ...info.content, ...stat.content })
        } catch (error: any) {
            console.error(error)
            return error
        }
    }
}


